var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputTipoInstrumento',{staticClass:"tipo_instrumento rounded rounded-lg",attrs:{"tool-tip-informacao":'',"multiplos":false},model:{value:(_vm.tipoInstrumento),callback:function ($$v) {_vm.tipoInstrumento=$$v},expression:"tipoInstrumento"}})
}
var staticRenderFns = []

export { render, staticRenderFns }